export default {
  name: 'timer',
  props: ['isSmall', 'title'],
  data() {
    return {
      time: '00:00:00',
    };
  },
  mounted() {
    let interval = 0;
    setInterval(() => {
      interval += 1;
      this.updateTime(interval);
    }, 1000);
  },
  methods: {
    updateTime(second) {
      let date = new Date(null);
      date.setSeconds(second);
      this.time = date.toISOString().substr(11, 8);
    },
  },
};
